// ui
import { Button, Typography, Modal, Box, Alert } from "@mui/material";
import DoDisturbAltIcon from "@mui/icons-material/DoDisturbAlt";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";

// jotai
import { useWindowSize } from "../../lib/useWindowSize";

interface ProductServiceStartStopModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  startStopDataInf: {
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  };
  setStartStopDataInf: (value: {
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }) => void;
  startStopData: () => void;
}

export function ProductServiceStartStopModal(
  props: ProductServiceStartStopModalProps
) {
  const {
    onModal,
    swCloseModal,
    startStopDataInf,
    setStartStopDataInf,
    startStopData,
  } = props;

  const { windowWidth, windowHeight } = useWindowSize();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: windowWidth > 568 ? "500px" : "calc(100% - 82px)",
    maxHeight: "70vh",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  return (
    <Modal
      open={onModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          style={{
            fontSize: "18px",
            color: "rgb(50 50 50)",
          }}
          key="cancelTitleBox"
          className="shippori-antique-regular"
        >
          取扱い停止・再開
        </Box>
        <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
          {startStopDataInf.status === "open" ? (
            <>
              <Alert severity="error">
                {startStopDataInf.key.startStop == "start" ? (
                  <>
                    取扱いが再開されます。
                    <br />
                    ※再開後、パートナーがエントリー可能となります。
                  </>
                ) : startStopDataInf.key.startStop == "stop" ? (
                  <>
                    取扱いが停止されます。
                    <br />
                    ※停止後、パートナーがエントリー不可能となります。
                    <br />
                    ※すでに登録済のエントリーに影響はありません。
                  </>
                ) : null}
              </Alert>
              <Box style={{ display: windowWidth > 385 ? "flex" : undefined }}>
                <Box
                  style={{
                    marginTop: "10px",
                    height: "40px",
                    width:
                      windowWidth > 385
                        ? "calc(50% - 5px)"
                        : "calc(100% - 10px)",
                    marginLeft: windowWidth > 385 ? undefined : "5px",
                  }}
                >
                  <Button
                    style={{
                      height: "40px",
                      width: "100%",
                      textTransform: "none",
                    }}
                    variant="contained"
                    onClick={startStopData}
                  >
                    <Box className="m-plus-rounded-1c-regular">
                      {startStopDataInf.key.startStop == "start"
                        ? "再開"
                        : "停止"}
                    </Box>
                    {startStopDataInf.key.startStop == "start" ? (
                      <PlayCircleOutlineIcon
                        sx={{ marginLeft: "6px", color: "white" }}
                        fontSize="medium"
                      />
                    ) : (
                      <DoDisturbAltIcon
                        sx={{ marginLeft: "6px", color: "white" }}
                        fontSize="medium"
                      />
                    )}
                  </Button>
                </Box>
                <Box
                  style={{
                    marginTop: "10px",
                    height: "40px",
                    width:
                      windowWidth > 385
                        ? "calc(50% - 5px)"
                        : "calc(100% - 10px)",
                    marginLeft: windowWidth > 385 ? "10px" : "5px",
                  }}
                >
                  <Button
                    variant="contained"
                    style={{
                      height: "40px",
                      width: "100%",
                      textTransform: "none",
                    }}
                    onClick={swCloseModal}
                  >
                    <Box className="m-plus-rounded-1c-regular">閉じる</Box>
                  </Button>
                </Box>
              </Box>
            </>
          ) : startStopDataInf.status === "success" ? (
            <>
              <Box className="shippori-antique-regular">成功しました。</Box>
              <Box>
                <Button
                  style={{
                    marginTop: "30px",
                    marginLeft: windowWidth > 385 ? "15%" : "5px",
                    marginBottom: "-25px",
                    height: "40px",
                    width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                    textTransform: "none",
                  }}
                  variant="contained"
                  onClick={swCloseModal}
                >
                  <Box className="m-plus-rounded-1c-regular">閉じる</Box>
                </Button>
              </Box>
            </>
          ) : startStopDataInf.status === "failed" ? (
            <>
              <Box className="shippori-antique-regular">
                {startStopDataInf.message}
              </Box>
              <Box>
                <Button
                  style={{
                    marginTop: "30px",
                    marginLeft: windowWidth > 385 ? "15%" : "5px",
                    marginBottom: "-25px",
                    height: "40px",
                    width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                    textTransform: "none",
                  }}
                  variant="contained"
                  onClick={() =>
                    setStartStopDataInf({
                      ...startStopDataInf,
                      status: "open",
                      message: "",
                    })
                  }
                >
                  <Box className="m-plus-rounded-1c-regular">戻る</Box>
                </Button>
              </Box>
            </>
          ) : null}
        </Typography>
      </Box>
    </Modal>
  );
}
